import type {MainStore} from "@/Stores/store";
import type {RouteLocationNormalizedLoaded} from "vue-router";

export default ($store: MainStore, route: RouteLocationNormalizedLoaded) => {
    return [
        {
            event: "Invitations\\InvitationCreated",
            callback: (e: {invitation_type: string; invitation_id: string}) => {
                if (e.invitation_type === "App\\Models\\Group") {
                    $store.incrementGroupInvitations();
                } else if (e.invitation_type === "App\\Models\\User") {
                    $store.incrementContactInvitations();
                }
            },
        },
        {
            event: "Conversations\\ConversationMessageSent",
            callback: (e: {conversation: string; message: string; sender: string}) => {
                const isViewingThisConversation =
                    route.name === "conversations.show" && route.params.conversation === e.conversation;
                if (e.sender !== $store.user.id && !isViewingThisConversation) {
                    $store.incrementUnreadConversations();
                }
            },
        },
    ];
};
